/**
 * Check if an item's rulebook(s) match any of the enabled rulebooks.
 * Supports both single string and array formats for backward compatibility.
 */
export function isRulebookEnabled(
  itemRulebook: string | string[],
  enabledRulebooks: string[]
): boolean {
  if (Array.isArray(itemRulebook)) {
    return itemRulebook.some((rb) => enabledRulebooks.includes(rb));
  }
  return enabledRulebooks.includes(itemRulebook);
}
